import createIcon from '../../createIcon';

/**
 * @component @name Person3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMzkgMTUuNTZDMTYuNzEgMTQuNyAxNC41MyAxNCAxMiAxNEM5LjQ3IDE0IDcuMjkgMTQuNyA1LjYxIDE1LjU2QzQuNjEgMTYuMDcgNCAxNy4xIDQgMTguMjJWMjFIMjBWMTguMjJDMjAgMTcuMSAxOS4zOSAxNi4wNyAxOC4zOSAxNS41NloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMCAxM0MxMC4xNyAxMyAxMy44MyAxMyAxNCAxM0MxNS42NiAxMyAxNyAxMS42NiAxNyAxMEMxNyA5LjI3IDE2LjczIDguNiAxNi4yOSA4LjA4QzE2LjQyIDcuNzUgMTYuNSA3LjM4IDE2LjUgN0MxNi41IDUuNzUgMTUuNzMgNC42OCAxNC42NCA0LjIzQzE0IDMuNDggMTMuMDYgMyAxMiAzQzEwLjk0IDMgMTAgMy40OCA5LjM2IDQuMjNDOC4yNyA0LjY4IDcuNSA1Ljc1IDcuNSA3QzcuNSA3LjM4IDcuNTggNy43NSA3LjcxIDguMDhDNy4yNyA4LjYgNyA5LjI3IDcgMTBDNyAxMS42NiA4LjM0IDEzIDEwIDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Person3 = createIcon('Person3', [
  [
    'path',
    {
      d: 'M18.39 15.56C16.71 14.7 14.53 14 12 14C9.47 14 7.29 14.7 5.61 15.56C4.61 16.07 4 17.1 4 18.22V21H20V18.22C20 17.1 19.39 16.07 18.39 15.56Z',
      key: '1io5h8',
    },
  ],
  [
    'path',
    {
      d: 'M10 13C10.17 13 13.83 13 14 13C15.66 13 17 11.66 17 10C17 9.27 16.73 8.6 16.29 8.08C16.42 7.75 16.5 7.38 16.5 7C16.5 5.75 15.73 4.68 14.64 4.23C14 3.48 13.06 3 12 3C10.94 3 10 3.48 9.36 4.23C8.27 4.68 7.5 5.75 7.5 7C7.5 7.38 7.58 7.75 7.71 8.08C7.27 8.6 7 9.27 7 10C7 11.66 8.34 13 10 13Z',
      key: '1xcsyi',
    },
  ],
]);

export default Person3;
